import { render, staticRenderFns } from "./BattlesFilterPrice.vue?vue&type=template&id=47be7507&scoped=true"
import script from "./BattlesFilterPrice.vue?vue&type=script&lang=js"
export * from "./BattlesFilterPrice.vue?vue&type=script&lang=js"
import style0 from "./BattlesFilterPrice.vue?vue&type=style&index=0&id=47be7507&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be7507",
  null
  
)

export default component.exports